<template>
<div class="col-12 md:col-3">
<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4 flow_wrap_active">
<h3 class="text-primary"><b>{{$store.state.languages.lang_phrases.marka}}</b>: {{data.flow.brand.name}}</h3>

	<h4 class="text-primary">
		<template v-for="item in data.flow.translations">
		  <template v-if="$store.state.auth.user.preflang_id == item.language_id">
		    {{item.translation}}
		  </template>
		</template>
		

	- {{$store.state.languages.lang_phrases.aktif}}</h4>
	<p class="text-primary">{{flowtype}}</p>
	<template v-if="data.flow.start_date && data.flow.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_suresi}}:</b></p>
		<p class="text-primary">{{ $filters.momentFormat( data.flow.start_date," Do-MM-YYYY")}} - {{ $filters.momentFormat( data.flow.end_date," Do-MM-YYYY")}} </p>
	</template>

	<template v-if="data.flow.start_date && !data.flow.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_baslangici}}:</b></p>
		<p class="text-primary">{{ $filters.momentFormat( data.start_date," Do-MM-YYYY")}}</p>
	</template>

	<template v-if="!data.flow.start_date && data.flow.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_bitisi}}:</b></p>
		<p class="text-primary">{{ $filters.momentFormat( data.flow.end_date," Do-MM-YYYY")}}</p>
	</template>

	<div class="flex align-items-center justify-content-end " v-if="data.status=='finished' || data.status=='under_review' || data.status=='canceled'">
		
	</div>

	<div class="flex align-items-center justify-content-end " v-else>
		<Button :label="$store.state.languages.lang_phrases.baslayin"  class="p-button-white"  @click="gotoActiveFlow"></Button>
	</div>



</div>
</div>
</template>

<script>
export default {

  name: 'SupplierDashboardItem',
  props:["data"],
  data () {
    return {

    }
  },
  computed:{
  	flowtype()
  	{
  		if(this.data.type=="self_evaluation")
  		{
  			return this.$store.state.languages.lang_phrases.self_evaluation
  		}

  		if(this.data.type=="education")
  		{
  			return this.$store.state.languages.lang_phrases.education
  		}
  		if(this.data.type=="verification")
  		{
  			return this.$store.state.languages.lang_phrases.verification
  		}
  		if(this.data.type=="audit")
  		{
  			return this.$store.state.languages.lang_phrases.audit
  		}
  	}
  },
  methods:{
  	gotoActiveFlow()
  	{
  		this.$store.dispatch('evaluation/setMode',"submitting") 
  		this.$router.push({ name: 'Evaluation', params: { id:this.data.uuid } })
  	},
  },
}
</script>

<style lang="css" scoped>
</style>